import type { IconSvgObject } from './types';

const Coffee04Icon: IconSvgObject = [
  ["path", { d: "M17 9H4C3.44772 9 3 9.44772 3 10V14C3 17.866 6.13401 21 10 21C13.866 21 17 17.866 17 14V9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 9H18C19.6569 9 21 10.3431 21 12C21 13.6569 19.6569 15 18 15H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 3V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14 3V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M6 3V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default Coffee04Icon;
